import React from 'react';

export const initialState = {
    step: -1,
    isLoading: true,
    testData:{},
    incorrectAge: false,
    userAge: 0,
    noMenstrualPeriod: false,
    showNoMenstrualPeriod: false,
    isSpecialAnswer: false,
    showSpecialAnswer: false,
    selectedAnswers: {},
    selectedSpecialAnswer: -1,
    menopausePoints: 0,
    prampPoints: 0,
    perimpPoints: 0,
    canGoFurther: false,
    amountOfQuestions: 0,
    lastStep: false,
    thankYouPage: false,
    shouldScroll: false,
}

export const GlobalContext = React.createContext(initialState);